import app from '@frontend/application-container';
import { defineComponent, h } from 'vue';
import BarButton from '@components/bar-button';
import { show_smoothen_options_modal } from '@features/smoothness/state';
import { SmoothenStrengthIcon } from '..';
import { img } from '@phi/components';
import { ShowSmoothenOptionsTooltip } from '../show-smoothen-options-tooltip';

export const ShowSmoothenOptionsButton = defineComponent({
    setup() {
        return () => h(BarButton, {
            disabled: !app.state.loaded,
            id: 'show-smoothen-options-button',
            tippy: 'bottom',
            onClick: show_smoothen_options_modal,
        }, {
            icon: () => img(SmoothenStrengthIcon, 'Show smoothness strength options'),
            tooltip: ShowSmoothenOptionsTooltip,
        });
    },
});
